<template>
    <div style="max-width: 100%">
        <div class="d-flex flex-row justify-content-end mt-5" style="width: 100%" v-if="haveSearch &&  widthMd(370)">
            <div class="custom-search mt-2 mr-2 mb-0">
                <input type="text" class="search-query" v-model="search" placeholder="Pesquisar"
                       @keypress="emitWithEnter($event)">
                <i class="icon-search1" @click="$emit('searching', search)"></i>
            </div>
        </div>
        <div class="page-header pr-0" :class="haveSearch &&  widthMd(370) ? 'mt-0' : ''"
             style="max-width: 100vw">
            <li class="first" data-cy="page-header-title">{{ t(pageTitle) }} <p v-if="subTitle" class="ml-2" style="font-size: 12px"> {{subTitle}}</p></li>
            <div class="row justify-content-end"  >
                <div class="col-12 justify-content-end pb-1 pr-0 mr-0"
                     v-if="haveSearch && widthMd(500) && widthMd(370, '>')">
                    <div class="custom-search mr-0">
                        <input type="text" class="search-query pr-0" v-model="search" placeholder="Pesquisar"
                               @keypress="emitWithEnter($event)">
                        <i class="icon-search1" @click="$emit('searching', search)"></i>
                    </div>
                </div>
                <a class="btn mr-2" :class="secondIconBtnNewLink ? 'btn-primary' : 'btn-custom bg-btn'"
                   @click="$emit('secondActionLink')" v-if="secondBtnLink" id="secondbtnlink">
                    <i :class="secondIconBtnNewLink ? secondIconBtnNewLink : 'icon-circle-with-plus'"/>
                    {{ t(secondBtnLink) }}
                </a>
                <div class="custom-search" v-if="haveSearch && !widthMd(500)">
                    <input type="text" class="search-query" v-model="search" placeholder="Pesquisar"
                           @keypress="emitWithEnter($event)">
                    <i class="icon-search1" @click="$emit('searching', search)"></i>
                </div>
                <a class="btn btn-primary mr-2" id="btnTree"
                   @click="$emit('btnTree')" v-if="btnTree">
                    {{ btnTree }}
                </a>
                <a class="btn btn-primary mr-2" @click="$emit('copyLink')" v-if="copyLink" id="copy">
                    <i class="icon-copy"></i> {{ t(copyLink) }}
                </a>
                <a class="btn btn-custom mr-2" data-toggle="modal" data-target="#customModalTwo"
                   :class="secondIconBtnNew ? 'btn-primary' : 'bg-btn'"
                   @click="$emit('secondAction')" v-if="secondBtn" id="secondbtn">
                    <i :class="secondIconBtnNew ? secondIconBtnNew : 'icon-circle-with-plus'"/> {{ t(secondBtn) }}
                </a>
                <a class="btn btn-primary mr-1" id="filter" data-toggle="modal" data-target="#customModalTwo"
                   @click="$emit('filter')" v-if="filter">
                    Filtro
                </a>
                <div class="dropdown" v-if="dropdown">
                    <button class="btn btn-custom bg-btn ml-2 dropdown-toggle" type="button" id="dropdownMenu2"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Opções
                    </button>
                    <div class="dropdown-menu dropdown-menu-right w-auto" aria-labelledby="dropdownMenu2">
                        <button v-for="(iten, key) in dropdown" :key="key" class="dropdown-item" type="button"
                                :data-toggle="iten.modal ? 'modal' : ''"
                                :data-target="iten.modal ?'#customModalTwo' : ''"
                                @click="iten.emit ? $emit(iten.emit) : ''">
                            <i :class="iten.icon"></i> {{ t(iten.title) }}
                        </button>
                    </div>
                </div>
                <a class="btn btn-custom bg-btn" data-toggle="modal" data-target="#customModalTwo"
                   v-if="btnNew"
                   @click="$emit('newType')" id="new" data-cy="btn-new-page-header">
                    <i :class="iconBtnNew ? iconBtnNew : 'icon-circle-with-plus'"></i> {{ t(btnNew) }}
                </a>
                <div v-if="dropdownClient">
                    <div class="text-right ml-2">
                        <button data-cy="lot_index_dropdown" class="btn btn-custom bg-btn no-border" type="button"
                                id="import-buttom"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="icon-menu"/>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right dropdown-black dropdown-lot w-auto pr-2"
                             id="dropdown-import">
                            <div class="dropdown-item bg-hover-black" @click="this.$emit('uploadFileClient')">
                                <div class="row item-custom2 ml-1 text-white ">
                                    <i class="icon-folder_open mr-2 font-15"/>{{ t('CLIENTS.IMPORT_FILE') }} XLSX
                                </div>
                            </div>
                            <div class="dropdown-item bg-hover-black">
                                <a class="row item-custom2 ml-1 text-white" data-toggle="modal"
                                   data-target="#customModalTwo" @click="this.$emit('exportClient')">
                                    <i class="icon-file mr-2 font-15"/>{{ t('CLIENTS.EXPORT_FILE_CLIENT') }} XLSX
                                </a>
                            </div>

                            <div class="dropdown-item bg-hover-black">
                                <a class="row item-custom2 ml-1 text-white" href="Modelo para Importação Pessoas.xlsx"
                                   download>
                                    <i class="icon-arrow-with-circle-down mr-2 font-15"/>{{
                                        t('GENERAL.MSG.DOWNLOAD_FILE_EXEMPLE')
                                    }}
                                </a>
                            </div>

                            <div class="dropdown-item bg-hover-black">
                                <a class="row item-custom2 ml-1 text-white"
                                   @click="$router.push('/clientes/dashboard')">
                                    <i class="icon-show_chart mr-2 font-15"/>{{ t('GENERAL.MSG.DASHBOARD_PEOPLE') }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex" v-if="allotmentIndex || showAllotment">
                    <label class="mr-2 align-self-center" v-if="!widthMd(630) && allotmentsStore">Loteamentos:</label>
                    <select2 placeholder="Filtrar" :options="allotmentsStore"
                             v-if="!withNoneAllotment && allotmentsStore"
                             :settings="{width: widthMd(454) ? '180px' : '220px'}"
                             v-model="allotmentId"
                             @select="$emit('selectAllotment', allotmentId)">
                    </select2>
                    <select2 placeholder="Filtrar" :options="[{id: 'selecione', text: 'Nenhum'}, ...allotmentsStore]"
                             v-else-if="allotmentsStore"
                             :settings="{width: widthMd(454) ? '180px' : '220px'}"
                             v-model="allotmentId"
                             @select="$emit('selectAllotment', allotmentId)">
                    </select2>
                </div>
            </div>
            <slot name="container" v-if="hasSlot"></slot>
        </div>
    </div>
</template>
<script>

import {useI18n} from "vue-i18n";
import {mapState} from 'vuex';
import Select2 from 'vue3-select2-component';

export default {
    props: {
        pageTitle: {
            type: String,
            required: true
        },
        subTitle: {
            type: String,
            required: false
        },
        withNoneAllotment: {
            type: Boolean,
            default: false
        },
        hasSlot:{
            type: Boolean,
            default: false
        },
        showAllotment: {
            type: Boolean,
            default: false
        },
        allotmentIndex: {
            type: String,
            required: false,
        },
        btnNew: {
            type: String,
            required: false
        },
        secondBtn: {
            type: String,
            required: false
        },
        secondBtnLink: {
            type: String,
            required: false
        },
        iconBtnNew: {
            type: String,
            default: ''
        },
        secondIconBtnNew: {
            type: String,
            default: ''
        },
        secondIconBtnNewLink: {
            type: String,
            default: ''
        },
        dropdown: {
            type: Object,
            required: false
        },
        dropdownClient: {
            type: Boolean,
            required: false
        },
        copyLink: {
            type: String,
            required: false
        },
        filter: {
            type: Boolean,
            default: false
        },
        btnTree: {
            default: false
        },
        haveSearch: {
            type: Boolean,
            default: false
        },
        colorStatus: {
            type: String,
            default: '',
        },
        haveZoom: {
            type: Boolean,
            default: false
        },
    },
    emits: ['newType', 'filter', 'searching', 'copyLink', 'uploadFileClient', 'toggleMode', 'zoom_out', 'zoom_in','selectAllotment',
        'exportToPDF','secondAction', 'exportToPNG', 'exportToPNGMeadow', 'exportToPDFBroadway', 'exportToPDFSkyblue', 'exportToPNGMaterial',
    'secondActionLink','btnTree','exportClient', ],
    setup() {
        const {t} = useI18n();
        return {t,}
    },
    mounted() {
        this.allotmentId = this.allotmentIndex;
    },
    watch: {
        allotmentIndex() {
            this.allotmentId = this.allotmentIndex
        }
    },
    data() {
        return {
            allotmentId: null,
            search: null,
        }
    },
    components: {
        Select2,
    },
    computed: {
        ...mapState({
            allotmentsStore: 'allotments',
        }),
    },
    methods: {
        getNameAllotment() {
            if (!this.allotmentIndex) return 'Loteamentos';
            let name = this.allotmentsStore.find(i => i.id === this.allotmentIndex)?.text;
            if (name) return name;
            return 'Loteamentos';
        },
        emitWithEnter(log) {
            if (log.key == 'Enter') {
                this.$emit('searching', this.search);
            }
        },
        widthMd(size = 1025, smaller = '<') {
            if (smaller == '<') {
                return window.innerWidth < size;
            } else {
                return window.innerWidth > size;
            }
        },
    }
}
</script>

<style>
/* Estilo do botão dropdown de Exportar*/

.dropdown {
    position: relative;
    display: inline-block;
}

.dropdown-content {
    display: none;
    position: absolute;
    background-color: #f9f9f9;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
}

.dropdown-content a {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
}

.dropdown:hover .dropdown-content {
    display: block;
}

.dropdown-content a:hover {
    background-color: #f1f1f1
}

.dropbtn:focus {
    outline: none;
}

/* FIM Estilo do botão dropdown de Exportar*/

.first {
    border-radius: 0px;
    background: transparent;
    margin: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    padding: 1.5rem 0;
    font-size: 1.5rem;
    align-items: center;
}

.btn-custom {
    border: none;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    transition-duration: 0.4s;
    cursor: pointer;
}

.bg-btn {
    background-color: white !important;
    color: black !important;
    border: 1px solid #0e5e4e;
}

.bg-btn:hover, .bg-btn:focus {
    background-color: #0e5e4e !important;
    color: white !important;
}

.search-query::placeholder {
    color: #0e5e4e;
    opacity: 0.9
}
</style>
